import { all } from 'redux-saga/effects';
import winners from './winners';
import auth from './auth';
import profile from './profile';
import dailyDraw from './daily-draw';

export default function* () {
  yield all([winners(), auth(), profile(), dailyDraw()]);
}
